import {useCallback, useRef, useState} from 'react'
import {useTranslation} from 'react-i18next'

import Toast from 'components/Basic/Toast'
import {AIUsageService} from 'services/api'

type UseAIUsageExportResult = {
  downloadExport: () => Promise<void>
  isDownloading: boolean
}

export const useAIUsageExport = (): UseAIUsageExportResult => {
  const {t} = useTranslation(['aiUsage'])
  const [isDownloading, setIsDownloading] = useState(false)
  const isDownloadingRef = useRef(false)

  const downloadExport = useCallback(async () => {
    if (isDownloadingRef.current) {
      return
    }

    isDownloadingRef.current = true
    setIsDownloading(true)

    try {
      const result = await AIUsageService.getAIUsageExport()

      if (result.isEmpty) {
        Toast({
          message: t('aiUsage:AI_USAGE_TOAST_EXPORT_NO_RESULTS'),
          type: 'info',
          customId: 'ai-usage-export-no-results',
        })
        return
      }

      if (result.fileUrl) {
        window.open(result.fileUrl, '_self')
      }
    } catch {
      Toast({
        message: t('aiUsage:AI_USAGE_TOAST_EXPORT_ERROR'),
        type: 'error',
        customId: 'ai-usage-export-error',
      })
    } finally {
      isDownloadingRef.current = false
      setIsDownloading(false)
    }
  }, [t])

  return {
    downloadExport,
    isDownloading,
  }
}
